// extracted by mini-css-extract-plugin
module.exports = {"p1sg4vac":"p1sg4vac","label":"label"};